<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>ई-समझौता  </h2>
                </div>
                <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>  
                </div>
                <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
                    (mouseout)="showpayment(false,'1')" id='1' *ngIf="webFirst">
                    <div
                        style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe class="i-frame" src="https://www.youtube.com/embed/RLUj"
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div> -->



                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                    id="2">

                    <label for="" class="mt-3">पे जी में, ई-एग्रीमेंट सुविधा आपकी अनुबंध प्रक्रियाओं को सुव्यवस्थित और सरल बनाने के लिए डिज़ाइन की गई है। बोझिल कागजी अनुबंधों और मैन्युअल हस्ताक्षरों से निपटने के दिन गए। ई-समझौते के साथ, हम आपके लिए एक डिजिटल समाधान लाते हैं जो दक्षता, सुरक्षा और सुविधा को बढ़ाता है।  </label>
                    <label for="" class="mt-3">ई-समझौता हमारी भुगतान गेटवे सेवाओं के साथ समझौते में शामिल होने के आपके तरीके को बदल देता है। हमारे प्लेटफ़ॉर्म में निर्बाध रूप से एकीकृत, यह सुविधा आपको एक सुरक्षित और उपयोगकर्ता-अनुकूल वातावरण में इलेक्ट्रॉनिक रूप से अनुबंध बनाने, समीक्षा करने और अंतिम रूप देने में सक्षम बनाती है। </label>

                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="3">
                    <h2>
                        ई-समझौते के मुख्य लाभ: 
                    </h2>

                    <ul>
                        <li class="mt-3">
                            <b> सहज वर्कफ़्लो:  </b>&nbsp;कागज-आधारित वर्कफ़्लो को अलविदा कहें। ई-समझौता आपको देरी और प्रशासनिक परेशानियों को कम करते हुए, पूरी तरह से ऑनलाइन समझौतों को शुरू करने, बातचीत करने और अंतिम रूप देने की अनुमति देता है। 
                        </li>
                        <li class="mt-3">
                            <b>कहीं भी, कभी भी पहुंच: </b>&nbsp; इंटरनेट कनेक्शन के साथ कहीं से भी अपने अनुबंधों तक पहुंचें। भौतिक प्रतियों या व्यक्तिगत बैठकों के लिए अब और इंतजार नहीं करना पड़ेगा। 
                        </li>

                        <li class="mt-3">
                            <b> तेज़ प्रसंस्करण:</b>&nbsp; स्वचालित सूचनाओं, अनुस्मारक और अनुबंध की स्थिति पर वास्तविक समय अपडेट के साथ अनुबंध प्रक्रिया में तेजी लाएं। 
                        </li>

                        <li class="mt-3">
                            <b> उन्नत सुरक्षा: </b>&nbsp; आपके डेटा की सुरक्षा सर्वोपरि है। ई-समझौता संवेदनशील जानकारी की सुरक्षा के लिए सुरक्षित दस्तावेज़ प्रसारण, डिजिटल प्रमाणीकरण और एन्क्रिप्शन सुनिश्चित करता है। 


                        </li>
                    </ul>

                </div>

                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'4')" (mouseout)="showpayment(false,'4')"
                    id="4">
                    <h2>
                        अपना ई-साइन कैसे करें? 
                    </h2>
                    <label for="">निम्नलिखित चरण ई-साइन पर हस्ताक्षर करने की प्रक्रिया की रूपरेखा तैयार करते हैं। </label>

                    <label for="" class="mt-4"><b>चरण 1:&nbsp;</b> मर्चेंट डैशबोर्ड में लॉग इन करें 

                    </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/login.png" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-4"><b>चरण 2:&nbsp;</b>सेटिंग दस्तावेज़ विवरण पर जाएँ। समझौते पर ई-हस्ताक्षर करने से पहले पीईपी स्थिति और उत्पाद/सेवा विवरण का चयन करें।  </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-2.png" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    
                    <label for="" class="mt-4">यदि व्यापारी एक राजनीतिक रूप से उजागर व्यक्ति (पीईपी) है, तो उन्हें 'हां' पर क्लिक करना चाहिए, सभी आवश्यक विवरण भरें और फिर 'सहेजें' बटन पर क्लिक करें।   </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-3.png" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-4">यदि व्यापारी एक राजनीतिक रूप से उजागर व्यक्ति (पीईपी) है, तो उन्हें 'हां' पर क्लिक करना चाहिए, सभी आवश्यक विवरण भरें और फिर 'सहेजें' बटन पर क्लिक करें।    </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-4.png" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-4"> <b>चरण 3: &nbsp;</b> सभी आवश्यक विवरण भरने के बाद व्यापारी को सेव बटन पर क्लिक करना चाहिए </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-5.png" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-4"> <b>चरण 4: &nbsp;</b> डैशबोर्ड पर, जब पे जी के साथ समझौता तैयार हो जाए, तो व्यापारी को समझौते पर हस्ताक्षर करने के लिए 'सत्यापित करें' बटन पर क्लिक करना चाहिए। </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-6.png" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-4"> <b>चरण 5: &nbsp;</b> ई-साइन प्रक्रिया जारी रखने के लिए गो फॉर ई-साइन बटन पर क्लिक करें। </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-7.png" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-4"> <b>चरण 6: &nbsp;</b> अब व्यापारी को स्क्रीन पर प्रदर्शित मोबाइल नंबर से जुड़े आधार नंबर को कॉपी करना चाहिए और क्लिक हियर टू साइन बटन पर क्लिक करना चाहिए। </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-8.png" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-4"> <b>चरण 7: &nbsp;</b>डिजीओ विंडो खुलेगी, सत्यापन के लिए मोबाइल नंबर पर कोड भेजें पर क्लिक करें।  </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-9.png" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-4"> <b>चरण 8: &nbsp;</b>व्यापारी को मोबाइल फोन पर एक ओटीपी प्राप्त होगा, व्यापारी को उस ओटीपी को यहां दर्ज करना होगा। </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-10.png" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-4"> <b>चरण 9: &nbsp;</b>ओटीपी दर्ज करने के बाद प्रक्रिया जारी रखने के लिए व्यापारी को सबमिट बटन पर क्लिक करना चाहिए। </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-11.png" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-4"> <b>चरण 10: &nbsp;</b>समझौते पर हस्ताक्षर करने के लिए साइन नाउ बटन पर क्लिक करें। </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-12.png" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-4"> <b>चरण 11: &nbsp;</b>व्यापारी को आखिरी विंडो से कॉपी किया हुआ आधार नंबर यहां पेस्ट करना चाहिए, व्यापारी को आधार सत्यापन के लिए एक ओटीपी प्राप्त होगा, उस ओटीपी को दर्ज करें और सबमिट बटन पर क्लिक करें। 

                    </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-13.png" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-4"> <b>चरण 12: &nbsp;</b>जब व्यापारी 'सबमिट' बटन पर क्लिक करता है और उसका खाता पे जी के साथ सफलतापूर्वक हस्ताक्षरित हो जाता है, तो व्यापारी डिजीओ टैब को बंद कर सकता है। दस्तावेज़ पर हस्ताक्षर करने के बाद व्यापारी अपनी ई-साइन प्रक्रिया की स्थिति की जांच कर सकते हैं। </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-14.png" width="100%" height="100%" alt="">
                        </div>
                        <div class="col-md-12 mt-4">
                            <img src="./assets/e-15.png" width="100%" height="100%" alt="">
                        </div>


                    </div>  

                    
               
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4  hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        विषयसूची:
                    </h5>
                </div>
                <!-- <div class="col-md-12 mt-2">
                    <a href="#1"> <div class="row">
                        <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                alt=""> &nbsp;</div>
                        <div class="col-md-10">
                            <span style="cursor: pointer;" class="videoHover"
                                [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                                E-Agreement </span>
                        </div>
                    </div></a>
                </div> -->
                <div class="col-md-12 mt-3">
                    <a href="#2">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'color':colors=='2'}"
                                    (click)="color('2')">
                                    ई-समझौता </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#3">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')">लाभ  
                                </span>
                            </div>
                        </div>
                    </a>
                </div>

                <div class="col-md-12 mt-3 ">
                    <a href="#4">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')">अपना ई-साइन कैसे करें?
                                </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">

                    <div class="row">
                        <div class="col-md-2"> <img src="./assets/ppt.svg" class="tab-icon intro" alt="">
                        </div>
                        <div class="col-md-8">
                            <a href="./assets/PPT/Hindi E-Agreement Process.pdf"
                                target="_blank">
                                <span style="cursor: pointer;" class="pptHover" [ngClass]="{'ppt':colors=='4'}"
                                    (click)="color('4')">
                                    ई-साइन अनुबंध </span>
                            </a>
                        </div>
                        <div class="col-md-2">
                            <a href="./assets/PPT/Hindi E-Agreement Process.pdf" download><img src="./assets/Downloadss.svg"
                                    alt="" width="100%"></a>
                        </div>
                    </div>

                </div>


            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8" style="width:70%">
                <a [routerLink]="['/pay-g']"> <button class="btn btn-color" (click)="menues('PayG')"> <img
                            src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;पे जी 
                    </button></a>

            </div>
            <div class="col-md-4        " style="width:30%">
                <a [routerLink]="['/web-integration']"> <button class="btn btn-color"
                        (click)="menues('Web Integration')">वेब एकीकरण
                        &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>

            </div>
        </div>
    </div>

</div>